import {
    SilResultProjectDeviceCreate,
    SilResultProjectDeviceSave,
    SilResultProjectDeviceNestedCreate,
    SilProjectDeviceNested,
    SilResultProjectDevice,
    SilProjectDevice,
} from "server/models"
import { SilDeviceFilter } from "client/utils"
import { LoadSilProjectDevicesByFilter } from "client/store"
import { POST, DELETE } from "client/store/utils"

export const LoadSilResultProjectDevicesByFilter = (filters: SilDeviceFilter) => (
    POST(
        "/silResultProjectDevice/getByFilter",
        JSON.stringify(filters),
    ).then((devices: SilResultProjectDevice[]) => devices)
)

export const SaveSilResultProjectDevice = (
    id: number,
    device: SilResultProjectDeviceCreate,
) => {
    const data: SilResultProjectDeviceSave = {
        id,
        device,
    }
    return POST(
        "/silResultProjectDevice/save",
        JSON.stringify(data),
    ).then((res) => {
        const resultDevice = res as SilResultProjectDevice
        return resultDevice.id || null
    })
}

export const AddSilResultProjectDeviceNested = (device: SilResultProjectDeviceNestedCreate) => (
    POST(
        "/silResultProjectDeviceNested/add",
        JSON.stringify(device),
    )
)

export const DeleteSilResultProjectDeviceNested = (parentDeviceId: number) => (
    DELETE(`/silResultProjectDeviceNested/deleteAll/${parentDeviceId}`)
    .then((removedRows: number) => removedRows)
)

const SaveResultDevice = (
    resultDevice: SilResultProjectDevice,
    projectDevice: SilProjectDevice,
) => {
    const resultDeviceId = resultDevice ? resultDevice.id : null

    const newResultDeviceData: SilResultProjectDeviceCreate = {
        projectId: projectDevice.projectId,
        deviceId: projectDevice.deviceId,
        projectDeviceId: !projectDevice.deviceId && !projectDevice.qidProductId ? projectDevice.id : null,

        qidProductId: projectDevice.qidProductId,
        qidModelId: projectDevice.qidModelId,
        qidSafetyFunctionId: projectDevice.qidSafetyFunctionId,
        qidOptionId: projectDevice.qidOptionId,
        qidDatapointId: projectDevice.qidDatapointId,

        qidModelName: projectDevice.qidModelName,
        qidSafetyFunctionName: projectDevice.qidSafetyFunctionName,
        qidOptionName: projectDevice.qidOptionName,
        qidDatapointDate: projectDevice.qidDatapointDate,
        qidMethod: projectDevice.qidMethod,

        manufacturer: projectDevice.manufacturer,
        name: projectDevice.name,
        logoId: projectDevice.logoId,
        description: projectDevice.description,
        reference: projectDevice.reference,
        nested: projectDevice.nested,
        type: projectDevice.type,
        lowDemandMode: projectDevice.lowDemandMode,
        highDemandMode: projectDevice.highDemandMode,
        continuousMode: projectDevice.continuousMode,
        logicSolver: projectDevice.logicSolver,
        provenInUse: projectDevice.provenInUse,

        failureRate: projectDevice.failureRate,
        sff: projectDevice.sff,
        dc: projectDevice.dc,
        pfd: projectDevice.pfd,
        pfh: projectDevice.pfh,
        sil: projectDevice.sil,

        sd: projectDevice.sd,
        su: projectDevice.su,
        dd: projectDevice.dd,
        du: projectDevice.du,
    }

    return SaveSilResultProjectDevice(resultDeviceId, newResultDeviceData)
    .then((newResultDeviceId) => (
        DeleteSilResultProjectDeviceNested(resultDeviceId)
        .then(() => {
            const promiseArray: Promise<any>[] = []
            projectDevice.nestedDevices.forEach((row) => {
                const nested = row as SilProjectDeviceNested

                const newNested: SilResultProjectDeviceNestedCreate = {
                    parentDeviceId: newResultDeviceId || resultDeviceId,
                    deviceId: nested.deviceId,
                    projectDeviceId: nested.projectDeviceId,

                    qidProductId: nested.qidProductId,
                    qidModelId: nested.qidModelId,
                    qidSafetyFunctionId: nested.qidSafetyFunctionId,
                    qidOptionId: nested.qidOptionId,
                    qidDatapointId: nested.qidDatapointId,

                    qidModelName: nested.qidModelName,
                    qidSafetyFunctionName: nested.qidSafetyFunctionName,
                    qidOptionName: nested.qidOptionName,
                    qidDatapointDate: nested.qidDatapointDate,
                    qidMethod: nested.qidMethod,

                    manufacturer: nested.manufacturer,
                    name: nested.name,
                    logoId: nested.logoId,
                    type: nested.type,
                    mode: nested.mode,
                    logicSolver: nested.logicSolver,
                    provenInUse: nested.provenInUse,

                    sd: nested.sd,
                    su: nested.su,
                    dd: nested.dd,
                    du: nested.du,

                    order: nested.order,
                }

                promiseArray.push(
                    AddSilResultProjectDeviceNested(newNested),
                )
            })

            return Promise.all(promiseArray)
        })
    ))
}

export const UpdateSilResultProjectDevice = (filters: SilDeviceFilter) => (
    Promise.all([
        LoadSilResultProjectDevicesByFilter(filters),
        LoadSilProjectDevicesByFilter(filters),
    ]).then(([resultDevices, projectDevices]) => {
        if (resultDevices.length === 1 && projectDevices.length === 1) {
            return SaveResultDevice(resultDevices[0], projectDevices[0])
        }

        return Promise.all([])
    })
)

export const AddSilResultProjectDevice = (filters: SilDeviceFilter) => (
    Promise.all([
        LoadSilResultProjectDevicesByFilter(filters),
        LoadSilProjectDevicesByFilter(filters),
    ]).then(([resultDevices, projectDevices]) => {
        if (resultDevices.length === 0 && projectDevices.length === 1) {
            return SaveResultDevice(null, projectDevices[0])
        }

        return Promise.all([])
    })
)
